import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class CustomerSUKService {

  public _SUKService = environment.SUKService;
    public _httpOptions;
    public sessionId : string
    constructor(private http: HttpClient) { 
      this.sessionId = sessionStorage["SessionId"]
      this._httpOptions = {
        headers: new HttpHeaders({ 'SessionId':this.sessionId })
      };
    
    }

    SUKServiceInit() {
     

      var Query = this._SUKService ;
      // console.log(Query);
  
      return this.http.get<{ data: any }>(Query,this._httpOptions).pipe(map(data => {
        const resultJSON = JSON.parse(JSON.stringify(data));
        // console.log(resultJSON);        
        return data;
      }));
    }

    InserSUK(SUK: object) {
     

      // console.log("Create");
      var Query = this._SUKService;
      return this.http.post<{ data: any }>(Query, SUK,this._httpOptions);
    }
    UpdateSUK(SUK: object) {
    

      // console.log("Update");
      var Query = this._SUKService;
      // console.log(Query);
      return this.http.put<{ data: any }>(Query, SUK,this._httpOptions);
    }

    edit(SUK: FormData)
  {     
   
    var Query = this._SUKService;
    // console.log(Query);
    return this.http.put<{data:any}>(Query,SUK,this._httpOptions);
  }
  create(SUK: FormData) {
   

    var Query = this._SUKService;
    return this.http.post<{ data: any }>(Query, SUK,this._httpOptions);
  }

  DeleteSKU(SKUID: string) {
   

    var Query = this._SUKService + '/DeleteSKU' +'/'+SKUID;
    return this.http.post<{ data: any }>(Query, SKUID,this._httpOptions);
  }


    GetById(customerSiteId:string): Observable<any>{
      

      var Query = this._SUKService + '/GetById' +'/'+ customerSiteId;
      // console.log(Query);
      return this.http.get<{ data: any }>(Query,this._httpOptions);
    }
    uploadSUK(SUK: FormData) {
      // console.log(SUK);
      this.http.post<any>(this._SUKService+'/Upload', SUK).subscribe(
        (res) => console.log(res),
        (err) => console.log(err)
      );
    }
}
